import { Axios } from 'utils/AxiosConfig'

export const getTransactions = async (payload) => {
  const { data: response } = await Axios.get(`member/package-transaction`, payload)
  return response
}
export const getDetailTransactionById = async (id) => {
  const { data: response } = await Axios.get(`member/package-transaction/${id}`)
  return response
}
